<template src="../templates/normal_fcont_103.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCardPrint from '../components/AppDownloadCardPrint'
import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  data() {
    return {
      articleId: '103',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadCardPrint
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['103-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['103-3']}
    ]};

  }
};
</script>
<style >
.p_upside {
	margin-top: 30px;
}
</style>

